export default "__VITE_ASSET__5e8b1405__"